"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContentResultFromJSON = AdminContentResultFromJSON;
exports.AdminContentResultFromJSONTyped = AdminContentResultFromJSONTyped;
exports.AdminContentResultToJSON = AdminContentResultToJSON;
exports.AdminContentResultToJSONTyped = AdminContentResultToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AdminContentResultFromJSON(json) {
    return AdminContentResultFromJSONTyped(json, false);
}
function AdminContentResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'error': !(0, runtime_1.exists)(json, 'error') ? undefined : (0, _1.ErrorDataFromJSON)(json['error']),
        'data': (0, _1.AdminContentFromJSON)(json['data']),
        'result': (0, _1.ResultTypeFromJSON)(json['result']),
        'status': (0, _1.HTTPStatusCodeFromJSON)(json['status']),
    };
}
function AdminContentResultToJSON(value) {
    return AdminContentResultToJSONTyped(value, false);
}
function AdminContentResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error': (0, _1.ErrorDataToJSON)(value.error),
        'data': (0, _1.AdminContentToJSON)(value.data),
        'result': (0, _1.ResultTypeToJSON)(value.result),
        'status': (0, _1.HTTPStatusCodeToJSON)(value.status),
    };
}
